import { SessionDto } from 'src/app/shared/vive-api/vive-api-models';

import { User } from '../classes/models';

/**
 * `GET|POST /api/v3/auth/session` as this app reads it. The envelope is the
 * generated `SessionDto`; `user` is the server-held JWT payload (minus
 * jti/iat/exp), which this app has always read as a `User`. The intersection
 * keeps every AppSession a `SessionDto`, so it can be handed out as one.
 */
export type AppSession = SessionDto & { user: User };

/**
 * Read a session body from the API as an AppSession. Nothing is converted: the
 * cast only narrows `user` from the generated type to that type as a `User`.
 */
export function toAppSession(session: SessionDto): AppSession {
  return { ...session, user: session.user as AppSession['user'] };
}
